export const confirmClicked = () => ({
  type: 'Box Summary - Confirm Clicked',
});
